import { Environments } from '../app/layout/model/interfaces/environments.interface';
import { View } from '../app/layout/model/interfaces/view.interface';

export const appConfig: Partial<Environments> = window.APP_CONFIG ?? {};

function assertString(value: unknown, key: string): string {
  if (typeof value !== 'string') {
    throw new Error(`Missing or invalid config: ${key}`);
  }
  return value;
}

function validatePlaceholders(config: Partial<Environments>): void {
  Object.entries(config)
    .filter(([_, value]) => typeof value === 'string')
    .forEach(([key, value]) => {
      if (value === `__${key}__`) {
        console.error(`⚠️ CONFIG ERROR: ${key} is not set properly. Found placeholder: "${value}"`);
      }
    });
}

export function buildProdEnvironment(overrides: Partial<Environments> = {}): Environments {

  if (overrides.SENTRY_DSN) {
    validatePlaceholders(appConfig);
  }

  const pages = (appConfig['ENABLED_PAGES'] as string || '').split(',').map(page => page.trim()) || [];
  const base: Environments = {
    SENTRY_DSN: assertString(appConfig.SENTRY_DSN, 'SENTRY_DSN'),
    SENTRY_RELEASE: assertString(appConfig.SENTRY_RELEASE, 'SENTRY_RELEASE'),
    SENTRY_ENVIRONMENT: assertString(appConfig.SENTRY_ENVIRONMENT, 'SENTRY_ENVIRONMENT'),
    SENTRY_TRACE_RATE: assertString(appConfig.SENTRY_TRACE_RATE, 'SENTRY_TRACE_RATE'),
    SENTRY_REPLAY_RATE: assertString(appConfig.SENTRY_REPLAY_RATE, 'SENTRY_REPLAY_RATE'),
    VERSION: assertString(appConfig.VERSION, 'VERSION'),
    ENABLED_PAGES: pages,
    PRODUCTION: true,
    STATIC_LOCATION: '/static/manager-studio/',
    TRANSLATIONS_LOCATION: '/assets/i18n/',
    API_URL: appConfig.API_URL || "/api/internal/",
    APP_URL: appConfig.APP_URL || "/app/",
    SUPPORT_CALL_ROUTE: "support-form/start_support_form/",
    FONTAWESOME: { style: 'fal' },
    DEFAULT_VIEW: { route: "/dashboard", iframeUrl: "dashboard/" } as View
  };

  return {
    ...base,
    ...overrides,
  };
}
